import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-button-toggle.css';
var getClassNameList = classNames.bind(styles);
var UitkButtonToggleGroup = function (props) {
  var children = props.children,
    className = props.className,
    wrapButtons = props.wrapButtons;
  var wrapperClassName = getClassNameList('uitk-button-toggle-group', className, {
    'uitk-button-toggle-group-wrap': wrapButtons
  });
  return React.createElement("ul", {
    className: wrapperClassName
  }, children);
};
UitkButtonToggleGroup.displayName = 'UitkButtonToggleGroup';
UitkButtonToggleGroup.defaultProps = {
  wrapButtons: false
};
export { UitkButtonToggleGroup };